import React from 'react';
import { testimonials } from '@/data/mock';
import { Card, CardContent } from '@/components/ui/card';
import { Quote } from 'lucide-react';

const TestimonialsSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <p className="text-xs uppercase tracking-[0.3em] text-red-600">Partners & Agencies</p>
          <h2 className="mt-4 text-3xl md:text-4xl font-semibold leading-tight text-gray-900">
            Trusted across transportation authorities, utilities, and municipal owners.
          </h2>
          <p className="mt-4 text-gray-600 text-lg">
            Project sponsors rely on Redspire when the work is high-stakes. Here’s how key clients describe the
            collaboration.
          </p>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {testimonials.map((testimonial) => (
            <Card key={testimonial.author} className="h-full border border-gray-100 shadow-lg">
              <CardContent className="p-6 flex flex-col gap-4">
                <Quote className="w-10 h-10 text-red-600" />
                <p className="text-lg text-gray-800 leading-relaxed flex-1">“{testimonial.quote}”</p>
                <div className="flex items-center gap-3">
                  <img
                    src={testimonial.photo}
                    alt={testimonial.author}
                    className="w-12 h-12 rounded-full object-cover"
                    loading="lazy"
                  />
                  <div>
                    <p className="font-semibold text-gray-900">{testimonial.author}</p>
                    <p className="text-sm text-gray-500">{testimonial.title}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;

